<template>
  <div class="map dbox">
    <div id="google-map-element">
    </div>
  </div>
</template>

<script>

import { registerMarkerAndInfoWindow } from '../../../../../utility';
import { head } from 'ramda';
import { MHTTPCL } from '../../../../../services/http/http-client';

export default {
  components: {
  },
  props: {
    selectedArtistData: {
      type: Object,
      required: true
    },
  },
  data: function() {
    return {

      // Mark: Data
    };
  },
  mounted: function() {
    window.onDateClick=this.onDateClick
  },
  watch: {
    selectedArtistData: {
      immediate: true,
      handler: function(newVal, oldVal) {
        const { artist_booking_locations_arr } = newVal;
        const artistBookingLocations = artist_booking_locations_arr || [];
        // console.log("artistBookingLocations::",artistBookingLocations);
        setTimeout(() => {

          const mapElement = document.getElementById('google-map-element');

          // Map Initialization
          
          const map = new google.maps.Map(mapElement, {
            center: {
              lat: 39.12346492579531, 
              lng: 13.99999999999999
            },
            zoom: 2,
          });

          // Marker placement


          const markers = artistBookingLocations.map(location => new google.maps.Marker({
            map,
            position: {
              lat: parseFloat(location.latitude), 
              lng: parseFloat(location.longitude)
            },
            label: head(location.booking_location_name),
            title: location.booking_location_name,
          }));
          
          const getContentString = ({
            bookingLocationName,
            startDate,
            address1,
            city,
            calendar_date_id
          }) => `
          <h4 class="ut-link ut-text-accent5"><a class="ut-link ut-text-accent5" href="${MHTTPCL.baseUrl}/${MHTTPCL.clientName}/v2/#/main/booking/booking_list/${calendar_date_id}/overview">${startDate}</a></h4>
          <h4>${bookingLocationName}</h4>
          <span>${address1}</span>,&nbsp<span>${city}</span>
          `

          const infoWindows  = artistBookingLocations.map(location => {
            return new google.maps.InfoWindow({
              content: getContentString({
                bookingLocationName: location.booking_location_name,
                startDate: location.start_date,
                address1: location.address1,
                city: location.city,
                calendar_date_id:location.calendar_date_id
              })
            })
          });

          registerMarkerAndInfoWindow(this, map, markers, infoWindows, google.maps.Animation.BOUNCE);

        }, 10);
      }
    }
  },
  computed: {
  },
  methods: {
    onDateClick:function(){
      console.log("MAP,amp")
    }
    // Mark: Methods
  },
}

</script>

<style lang="scss" scoped>

  #google-map-element {
    height: 100%;
  }

</style>
